import CampaignDiscount from '@albelli/discounts-campaignproductdisplayclient';
import { domainPrefix } from '../config/domainPrefix';
import useVendor from '../hooks/useVendor';

let campaignDiscount;

/**
 * Verify that URL contains CampaignId (UUID) param and it has a value
 * @return {String}
 */
export default function useCampaignDiscount(): CampaignDiscount {
    const vendor = useVendor();

    if (!campaignDiscount) {
        campaignDiscount = new CampaignDiscount(`https://${domainPrefix}${vendor}`, {
            validDetector: ['param'],
            apiVersion: 2,
        });
    }
    return campaignDiscount;
}
